const NGTConfigKey = {};

NGTConfigKey.SKIPPABLE_CONTENT = "ngt.skippableContent";
NGTConfigKey.USE_AUTO_VOICEOVER = "ngt.useAutoVoiceOver";
NGTConfigKey.SCENARIOS = "ngt.scenarios";
NGTConfigKey.MAX_CHARACTER_INPUT_PER_MESSAGE = "conversations.maxCharacterInputPerMessage";
NGTConfigKey.DEFAULT_MAX_PLAYER_TURNS = "conversations.defaultMaxPlayerTurns";
NGTConfigKey.MINIMUM_REFLECTION_TURNS = "reflections.minimumReflectionTurns";
NGTConfigKey.MAXIMUM_REFLECTION_TURNS = "reflections.maximumReflectionTurns";

NGTConfigKey.BACKEND_ENDPOINT = "backend.endpoint";
NGTConfigKey.BACKEND_API_KEY = "backend.apiKey";
NGTConfigKey.BACKEND_API_VERSION = "backend.apiVersion";

NGTConfigKey.APP_ID = "general.appID";
NGTConfigKey.BUILD = "general.build";
NGTConfigKey.COMMIT_HASH = "general.commitHash";
NGTConfigKey.ENVIRONMENT = "general.environment";
NGTConfigKey.APP_VERSION = "general.appVersion";

NGTConfigKey.PLATFORM_API_ENDPOINT = "platform.apiEndpoint";
NGTConfigKey.PLATFORM_API_VERSION = "platform.apiVersion";
NGTConfigKey.PLATFORM_INTEGRATION_ENABLED = "platform.integrationEnabled";


export default NGTConfigKey;